<template>
  <v-container fluid class="pt-10">
    <v-row dense no-gutters class="pa-0">
      <v-col cols="9"></v-col>
      <!--<v-col cols="12" class="d-flex justify-end px-2" style="gap:8px">-->
      <v-col cols="3" class="d-flex justify-space-around">
        <span class="px-1" v-for="opt in options" :key="opt.value" style="font-size: .8rem;">{{ opt.text }}</span>
      </v-col>
    </v-row>
    <v-divider />
    <div v-for="section in filteredSections" :key="section.name" class="pa-0">
      <v-row dense align="center" :style="section.headerStyle">
        <v-col cols="9" class="px-2">
          <span style="font-size:18px; font-weight:500;">{{
            section.name
          }}</span>
        </v-col>
        <v-col cols="3" class="d-flex justify-space-around px-2">
          <v-tooltip
            v-for="opt in options"
            :key="opt.value"
            bottom
            color="#000000"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                depressed
                :v-bind="attrs"
                v-on="on"
                :disabled="isReadOnly || section.disabled"
                @click="setSection(section.fields, opt.value)"
                class="radioButtonSelector"
              >
                <!--<v-img src="img/radiobutton-all.svg" style="width: 16px; height: 30px;"/>-->
                <v-img src="https://tweem.com/dam/worktime/radiobutton-all.svg" style="width: 16px; height: 30px;"/>
              </v-btn>
            </template>
            <span>{{ $t('wkt.admin.profiles.edit-window.select_all.tooltip') }}</span>
          </v-tooltip>
        </v-col>
      </v-row>

      <v-row
        v-for="item in section.items"
        :key="item.field"       
        dense
        no-gutters
        align="center"
        class="px-0"
      >
        <v-col cols="9" class="px-2">
          <span v-if="item.type !== 'switch'" style="font-size:14px" :style="item.labelStyle">{{ item.label }}</span>
        </v-col>
        <v-col cols="3" class="d-flex justify-space-around px-2">
          <!-- Si es switch, renderiza v-switch -->
          <v-switch
            :label ="item.label"
            v-if="item.type === 'switch'"
            v-model="data[item.field]"
            @change="$emit('update:data', data)"
            :disabled="isReadOnly || section.disabled"
            :style="item.switchStyle"
            hide-details
          />
          <!-- Si es radio, sigue igual -->
          <v-radio-group
            v-else
            v-model="data[item.field]"
            @change="$emit('update:data', data)"
            dense
            row
            no-gutters
            :disabled="isReadOnly || section.disabled"
            class="adminsRadButtonsRow"
          >
            <v-radio
              v-for="opt in options"
              :key="opt.value"
              :value="opt.value"
              label=""
              hide-details
              class="mx-1"
            />
          </v-radio-group>
        </v-col>
      </v-row>
    </div>
  </v-container>
</template>

<script>
export default {
  name: "AdminAccessModuleTab",
  props: ['data','isReadOnly','company','iAmPartner','isSuperAdmin'],
  data() {
    return {
      options: [
        { value: 0, text: this.$t('wkt.admin.profiles.edit-window.not_allowed') },
        { value: 1, text: this.$t('wkt.admin.profiles.edit-window.read_only') },
        { value: 2, text: this.$t('wkt.admin.profiles.edit-window.read_write') },
      ],
      sections: [
        {
          name: this.$t('wkt.admin.profiles.edit-window.all_sections'),
          headerStyle: "font-size:20px; font-weight:500; color:black; margin-top:10px; margin-bottom:10px",
          fields: ["moduleStaff","moduleHolidays","moduleTeams","moduleHCalendar",
            "moduleAssessments","moduleMessages","moduleNews","moduleSurveys","moduleDaily","moduleMonthly",
            "moduleEmployee","moduleTelework","moduleProjects","modulePlanning","moduleCalendar",
            "moduleProcedures", "moduleTasks", "moduleWorkflows", "moduleDocuments", "modulePDocuments","moduleDocumentsExternal",
            "moduleComplaintConfig","moduleComplaint","moduleExpenseSheet","moduleExpenseSheetCategory",
            "moduleVPolicy","moduleWorkplace","moduleDepartments","moduleLegalEntity","modulePForms","moduleDocumentCategory",
            "moduleDocumentsCategoryExternal","modulePDefinition","moduleActivityType","moduleChatConfig","moduleGConfig",
            "moduleGCustomize","moduleIntegration","moduleProfiles","modulePartnerCustomers","moduleLicense","modulePaidAbsencesCategory",
            "moduleAdditionalHoursCategory","moduleTraining","moduleTrainingBudget"],
          items: [],
        },
        {
          name: this.$t('wkt.admin.profiles.edit-window.staff_group'),
          headerStyle: "background-color:#F8F8F8; font-size:20px; font-weight:500; color:black",
          fields: ["moduleStaff","moduleHolidays","moduleTeams","moduleHCalendar",
            "moduleAssessments","moduleMessages","moduleNews","moduleSurveys",],
          items: [
            { label: this.$t('wkt.admin.profiles.edit-window.staff'), field: "moduleStaff" },
            { label: this.$t('wkt.admin.profiles.edit-window.holidays'), field: "moduleHolidays" },
            { label: this.$t('wkt.admin.profiles.edit-window.teams'), field: "moduleTeams" },
            { label: this.$t('wkt.admin.profiles.edit-window.hcalendar'), field: "moduleHCalendar" },
            { label: this.$t('wkt.admin.profiles.edit-window.assessments'), field: "moduleAssessments" },
            { label: this.$t('wkt.admin.profiles.edit-window.messages'), field: "moduleMessages" },
            { label: this.$t('wkt.admin.profiles.edit-window.news'), field: "moduleNews" },
            { label: this.$t('wkt.admin.profiles.edit-window.survey'), field: "moduleSurveys" },
          ],
        },
        {
          name: this.$t('wkt.admin.profiles.edit-window.activity_group'),
          headerStyle:
            "background-color:#F8F8F8; font-size:20px; font-weight:500; color:black",
          fields: ["moduleDaily","moduleMonthly","moduleEmployee","moduleTelework",
            "moduleProjects","modulePlanning","moduleCalendar"],
          items: [
            { label: this.$t('wkt.admin.profiles.edit-window.daily'), field: "moduleDaily" },
            { label: this.$t('wkt.admin.profiles.edit-window.monthly'), field: "moduleMonthly" },
            { label: this.$t('wkt.admin.profiles.edit-window.employee'), field: "moduleEmployee" },
            { label: this.$t('wkt.admin.profiles.edit-window.telework'), field: "moduleTelework" },
            { label: this.$t('wkt.admin.profiles.edit-window.projects'), field: "moduleProjects" },
            { label: this.$t('wkt.admin.profiles.edit-window.planning'), field: "modulePlanning" },
            { label: this.$t('wkt.admin.profiles.edit-window.calendar'), field: "moduleCalendar" },
          ],
        },
        {
          name: this.$t('wkt.admin.profiles.edit-window.process_group'),
          headerStyle:"background-color:#F8F8F8; font-size:20px; font-weight:500; color:black",
          fields: ["moduleProcedures", "moduleTasks", "moduleWorkflows", "moduleDocuments", "modulePDocuments","moduleDocumentsExternal",
            "moduleComplaintConfig","moduleComplaint"],
          items: [
            { label: this.$t('wkt.admin.profiles.edit-window.procedures'), field: "moduleProcedures" },
            { label: this.$t('wkt.admin.profiles.edit-window.procedures-complete-requests'), field: "moduleProceduresCompleteRequests", type:"switch", switchStyle:"position:relative;right:810px; bottom:11px",
                  labelStyle:"margin-left: 20px;" },
            { label: this.$t('wkt.admin.profiles.edit-window.procedures-mass-actions'), field: "moduleProceduresMassActions", type:"switch", switchStyle:"position:relative;right:799px; bottom:11px",
                  labelStyle:"margin-left: 20px;" },
            { label: this.$t('wkt.admin.profiles.edit-window.tasks'), field: "moduleTasks" },
            { label: this.$t('wkt.admin.profiles.edit-window.workflows'), field: "moduleWorkflows" },
            { label: this.$t('wkt.admin.profiles.edit-window.documents'), field: "moduleDocuments" },
            { label: this.$t('wkt.admin.profiles.edit-window.pdocuments'), field: "modulePDocuments" },
            { label: this.$t('wkt.admin.profiles.edit-window.documents_external'), field: "moduleDocumentsExternal" },
            { label: this.$t('wkt.admin.profiles.edit-window.training'), field: "moduleTraining" },
            { label: this.$t('wkt.admin.profiles.edit-window.training-budget'), field: "moduleTrainingBudget" },
            { label: this.$t('wkt.admin.profiles.edit-window.view_private_documents'), field: "viewPrivateDocuments", type:"switch", switchStyle:"position:relative;right:800px; bottom:11px",
                  labelStyle:"margin-left: 20px;" },
            { label: this.$t('wkt.admin.profiles.edit-window.complaint_config'), field: "moduleComplaintConfig" },
            { label: this.$t('wkt.admin.profiles.edit-window.complaint'), field: "moduleComplaint" },
          ],
        },
        {
          name: this.$t('wkt.admin.profiles.edit-window.expenses_group'),
          headerStyle:
            "background-color:#F8F8F8; font-size:20px; font-weight:500; color:black",
          fields: ["moduleExpenseSheet","moduleExpenseSheetCategory"],
          items: [
            { label: this.$t('wkt.admin.profiles.edit-window.expenses'), field: "moduleExpenseSheet" },
            { label: this.$t('wkt.admin.profiles.edit-window.expenses-categories'), field: "moduleExpenseSheetCategory" },
          ]
        },
        {
          name: this.$t('wkt.admin.profiles.edit-window.more_group'),
          headerStyle:
            "background-color:#F8F8F8; font-size:20px; font-weight:500; color:black",
          fields: ["moduleVPolicy","moduleWorkplace","moduleDepartments","moduleLegalEntity","modulePForms",
            "moduleDocumentCategory","moduleDocumentsCategoryExternal","modulePDefinition","moduleActivityType",
            "moduleChatConfig","moduleGConfig","moduleGCustomize","moduleIntegration","moduleProfiles",
            "modulePartnerCustomers","moduleLicense","modulePaidAbsencesCategory","moduleAdditionalHoursCategory"],
          items: [
            { label: this.$t('wkt.admin.profiles.edit-window.vpolicy'), field: "moduleVPolicy" },
            { label: this.$t('wkt.admin.profiles.edit-window.workplace'), field: "moduleWorkplace" },
            { label: this.$t('wkt.admin.profiles.edit-window.departments'), field: "moduleDepartments" },
            { label: this.$t('wkt.admin.legal-entities.title'), field: "moduleLegalEntity" },
            { label: this.$t('wkt.admin.profiles.edit-window.pforms'), field: "modulePForms" },
            { label: this.$t('wkt.admin.profiles.edit-window.documentCategory'), field: "moduleDocumentCategory" },
            { label: this.$t('wkt.admin.profiles.edit-window.document_category_external'), field: "moduleDocumentsCategoryExternal" },
            { label: this.$t('wkt.admin.profiles.edit-window.paid-absences-category'), field: "modulePaidAbsencesCategory" },
            { label: this.$t('wkt.admin.profiles.edit-window.pdefinition'), field: "modulePDefinition" },
            { label: this.$t('wkt.admin.profiles.edit-window.additional-hours-type'), field: "moduleAdditionalHoursCategory" },
            { label: this.$t('wkt.admin.profiles.edit-window.activityType'), field: "moduleActivityType" },
            { label: this.$t('wkt.admin.profiles.edit-window.chatconfig'), field: "moduleChatConfig" },
            { label: this.$t('wkt.admin.profiles.edit-window.gconfig'), field: "moduleGConfig" },
            { label: this.$t('wkt.admin.profiles.edit-window.gcustomize'), field: "moduleGCustomize" },
            { label: this.$t('wkt.admin.profiles.edit-window.integration'), field: "moduleIntegration" },
            { label: this.$t('wkt.admin.profiles.edit-window.profiles'), field: "moduleProfiles" },
            { label: this.$t('wkt.admin.profiles.edit-window.partner_customers'), field: "modulePartnerCustomers" },
            { label: this.$t('wkt.admin.profiles.edit-window.license'), field: "moduleLicense" },
          ],
        },
      ],
    };
  },
  computed: {
    filteredSections() {
      return this.sections.map(section => {
        // filtramos items
        const items = section.items.filter(item => {
          if (item.field === 'moduleDocumentsExternal') {
            return this.company.moduleDocumentsExternalEnabled;
          } else if (item.field === 'moduleDocumentsCategoryExternal') {
            return this.company.moduleDocumentsExternalEnabled;
          } else if (item.field === 'moduleChatConfig') {
            return this.company.moduleChatEnabled;
          } else if (item.field === 'modulePartnerCustomers') {
            return this.isSuperAdmin || this.iAmPartner;
          }
          return true;
        });

        const fields = section.fields.filter(f => {
          if (f == 'moduleDocumentsExternal') {
            return this.company.moduleDocumentsExternalEnabled;
          } else if (f == 'moduleDocumentsCategoryExternal') {
            return this.company.moduleDocumentsExternalEnabled;
          } else if (f == 'moduleChatConfig') {
            return this.company.moduleChatEnabled;
          } else if (f === 'modulePartnerCustomers') {
            return this.isSuperAdmin || this.iAmPartner;
          }
          return true;
        });

        return { ...section, items, fields };
      });
    }
  },
  methods: {
    setSection(fields, value) {
      fields.forEach((f) => {
        if (this.$set) {
          this.$set(this.data, f, value);
        }
      });
      this.$emit('update:data', this.data)
    },
  },
};
</script>
